import { EntityRepository, Repository } from "typeorm";
import { RackZoneMapping } from "./rack-zone-mapping-entity";

@EntityRepository(RackZoneMapping)
export class RackZoneMappingRepository extends Repository<RackZoneMapping>{

}
